































































































import { Component, Prop } from 'nuxt-property-decorator';
import IAElementComponent from './IAElementComponent.vue';
import { IaElementsInterface } from '@/types/contentContract';

@Component({
  name: 'QuestionAnswer'
})
export default class QuestionAnswer extends IAElementComponent {
  @Prop({ type: Object, default: () => [] })
  template!: IaElementsInterface;

  removeAnswers(): void {
    this.answers = [];
    this.isValidated = false;
    this.$refs.inputQA.forEach((elm) => {
      elm.lazyValue = '';
    });
  }
}
